import React, { FC, useState } from 'react';
import { Trans } from 'react-i18next';
import { Paper, Grid, Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import { Network } from 'api';
import { connectionPopup } from 'helpers';
import { useCurrentUser, useFeatures, useSocialConnections } from 'hooks';
import { CustomSVG } from 'components';
import Cookies from 'cookies';

const CONNECTION_CTA_VALUE = 'dismissed';

const useStyles = makeStyles(theme => ({
  root: {
    padding: `${theme.spacing(4)}px ${theme.spacing(10)}px ${theme.spacing(2)}px`,
    marginBottom: theme.spacing(3),
  },
  container: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  socialButton: {
    borderRadius: 4,
    color: theme.palette.common.white,
  },
  twitter: {
    backgroundColor: theme.custom.networks.twitter,
    '&:hover': {
      backgroundColor: theme.custom.networks.twitter,
    },
  },
  linkedIn: {
    backgroundColor: theme.custom.networks.linkedin,
    '&:hover': {
      backgroundColor: theme.custom.networks.twitter,
    },
  },
  buttonDismiss: {
    margin: '0 auto',
  },
}));

const Welcome: FC = () => {
  const classes = useStyles();
  const isDismissed = Cookies.connectionCta === CONNECTION_CTA_VALUE;

  const { id } = useCurrentUser();
  const { legacyAuthDomain } = useFeatures();
  const connections = useSocialConnections();
  const [dismissed, setDismissed] = useState(isDismissed);

  if (dismissed || connections.length) {
    return null;
  }

  function handleConnectTwitter() {
    connectionPopup(id, Network.Twitter, legacyAuthDomain);
  }

  function handleConnectLinkedIn() {
    connectionPopup(id, Network.Linkedin, legacyAuthDomain);
  }

  function handleDismiss() {
    Cookies.connectionCta = CONNECTION_CTA_VALUE;
    setDismissed(true);
  }

  const twitterButtonClasses = classNames(classes.socialButton, classes.twitter);
  const linkedInButtonClasses = classNames(classes.socialButton, classes.linkedIn);

  return (
    <Paper className={classes.root}>
      <Typography align="center" variant="subtitle2">
        <Trans i18nKey="onboarding:timelineConnections" />
      </Typography>
      <Grid className={classes.container} container alignItems="center" justify="space-evenly">
        <Grid item>
          <Button
            variant="contained"
            className={twitterButtonClasses}
            onClick={handleConnectTwitter}
            startIcon={<CustomSVG name="twitterOutline" size={20} viewBox="0 0 21 20" />}>
            <Trans i18nKey="user:connectTwitter" />
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            className={linkedInButtonClasses}
            onClick={handleConnectLinkedIn}
            startIcon={<CustomSVG name="linkedinOutline" size={20} />}>
            <Trans i18nKey="user:connectLinkedIn" />
          </Button>
        </Grid>
      </Grid>
      <div className={classes.buttonDismiss}>
        <Button fullWidth onClick={handleDismiss}>
          <Trans i18nKey="onboarding:timelineDismiss" />
        </Button>
      </div>
    </Paper>
  );
};

export default Welcome;
